import { gql } from "@apollo/client";

export const VALIDAR_CAMBIO_PROGRAMA = gql`
mutation ValidarCambioPrograma($input: ValidateCambioProgramaInput!) {
    aprobacionYRechazoCambioPrograma(input: $input) {
        idEvaluacion
    }
}`;